<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='10' :sm='10'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='14' :sm='14'>
            <a-form-item :label="'应用id'">
              <a-select
                style='width: 390px'
                v-model='queryParam.appssidList'
                mode='multiple'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>
        <a-row :gutter='24' style='margin-bottom: 30px'>
          <a-col :span='24' :sm='24'>
            <a-button style='margin-left: 20px' type='primary' @click='lookTodays'>查看当天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookThreedays'>查看近3天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookSevenDays'>查看近7天数据</a-button>
          </a-col>
        </a-row>
        <!--        <div style='margin-bottom: 10px'>广告：</div>-->
        <!--        -->
        <!--        <a-row :gutter='12' :style='undercreativeName ? "margin-bottom: 200px;" : "margin-bottom: 30px"'>-->
        <!--          <a-col :md='12' :sm='12'>-->
        <!--            <a-form-item :label="''">-->
        <!--              <a-select @change='creativeNameListChange' default-value='' style='width: 940px'-->
        <!--                        v-model='queryParam.creativeNameList' mode='multiple'>-->
        <!--                <a-select-option v-for='(item,index) in advertList' :key='item.adgroupName'>-->
        <!--                  {{ item.adgroupName }}-->
        <!--                </a-select-option>-->
        <!--              </a-select>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--        </a-row>-->
        <div style='margin-bottom: 10px;'>广告组：</div>
        <a-row :gutter='12' :style='underadvertGroup ? "margin-bottom: 200px;" : "margin-bottom: 20px"'>
          <a-col :md='12' :sm='12'>
            <a-form-item :label="''">
              <a-select @change='advertGroupListChange' default-value='' style='width: 940px'
                        v-model='queryParam.adGroupNameList' mode='multiple'>
                <a-select-option v-for='(item,index) in advertGroupList' :key='item.adgroupName'>
                  {{ item.adgroupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
                <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                  }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
              <!--               <a-button type='primary' @click="VisualChart('')" icon='bar-chart'-->
              <!--                         style='margin-left: 8px'>查看可视化图表</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='ipagination'
        :scroll='{ x: 2300, y: 2000 }'
        bordered
        @change='handleTableChange'
        @expand='extpand'
      >
      </a-table>


    </div>
    <RefundTradeModal ref='modalForm' @ok='modalFormOk'></RefundTradeModal>
    <custConvertListModal ref='custConvertListModal'></custConvertListModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getconvertDataAdgroupName, getlistAdvertisingContentSelect } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import custConvertListModal from '@/views/webpublic/platformOrder/ChartsModal/custConvertListModal.vue'

export default {
  name: 'AppList',
  components: {
    custConvertListModal,
    RefundTradeModal,
    Dict
  },
  data() {
    return {
      visible: false,
      REFUND_TRADE_STATUS,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      innerData: [],
      appList: [],
      advertGroupList: [],//广告组
      advertList: [],//广告
      undercreativeName: false,
      underadvertGroup: false,
      // 查询条件
      queryParam: {
        dataDt: [moment().add('days', -1), moment().add('days', 0)], //默认查看前一天
        appssidList: [],
        adGroupNameList: []
        // creativeNameList: []

      },
      loading: false,
      // 表头
      columns: [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'dataDt'
        },
        {
          title: '广告组',
          align: 'left',
          dataIndex: 'adgroupName',
          width: 400
        },
        {
          title: 'APP',
          align: 'left',
          dataIndex: 'appName'
        },
        // {
        //   title: '广告名称',
        //   align: 'left',
        //   dataIndex: 'creativeName'
        // },
        {
          title: '点击',
          align: 'left',
          dataIndex: 'clickCount'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installCount'
        },
        {
          title: '注册',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: '注册率（注册/安装）',
          align: 'left',
          dataIndex: 'regInstallRate'
        },
        {
          title: '紧急联系人',
          align: 'left',
          dataIndex: 'linkmanCount'
        },
        {
          title: '紧急联系人/注册',
          align: 'left',
          dataIndex: 'linkmanRegRate'
        },
        {
          title: '银行卡',
          align: 'left',
          dataIndex: 'bankcardCount'
        },
        {
          title: '银行卡/紧急联系人',
          align: 'left',
          dataIndex: 'bankLinkmanRate'
        },
        {
          title: '设备信息',
          align: 'left',
          dataIndex: 'jsonCount'
        },
        {
          title: '设备信息/银行卡',
          align: 'left',
          dataIndex: 'jsonBankcardRate'
        },
        {
          title: '个人信息',
          align: 'left',
          dataIndex: 'basicCount'
        },
        {
          title: '个人信息/设备信息',
          align: 'left',
          dataIndex: 'basicJsonRate'
        },
        {
          title: '个人信息/注册',
          align: 'left',
          dataIndex: 'jsonRegRate'
        },
        {
          title: '申请',
          align: 'left',
          dataIndex: 'applyCount'
        },
        {
          title: '申请/注册',
          align: 'left',
          dataIndex: 'applyRegRate'
        },
        {
          title: '放款',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: '放款/注册',
          align: 'left',
          dataIndex: 'loanRegRate'
        },
        {
          title: '放款/申请',
          align: 'left',
          dataIndex: 'loanApplyRate'
        }

      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.loadData(1)
    getApplist().then(res => {
      console.log('appListres-------->', res)
      this.appList = res.data || []
    })
    getlistAdvertisingContentSelect().then(res => {
      console.log('res-------------------》', res)
      this.advertGroupList = res.data.adgroupNameList || []
      this.advertList = res.data.creativeNameList || []
    })
  },
  methods: {
    creativeNameListChange(val) {
      console.log('val0000000000000', val.length)
      if (val.length > 2) {
        console.log('可以加高度')
        this.undercreativeName = true
      } else {
        this.undercreativeName = false
      }
    },
    advertGroupListChange(val) {
      if (val.length > 2) {
        this.underadvertGroup = true
      } else {
        this.underadvertGroup = false
      }
    },
    //计算利率的方法
    calculateRate(a, b) {
      if (a === 0 || b === 0) {
        return 0 + '%'
      } else if (b === 0) {
        console.log('除数为0啦救救我！！')
        // return '-'
        return 0 + '%'
      } else {
        return (a / b * 100).toFixed(2) + '%'
      }
    },
    lookSevenDays() {
      console.log('查看七天')
      this.queryParam.dataDt = [moment().add('days', -6), moment().add('days', 0)]
      this.loadData()
    },
    lookTodays() {
      console.log('查看当天')
      this.queryParam.dataDt = [moment().add('days', -0), moment().add('days', 0)]
      this.loadData()
    },
    lookThreedays() {
      console.log('查看三天')
      this.queryParam.dataDt = [moment().add('days', -2), moment().add('days', 0)]
      this.loadData()
    },
    searchReset() {
      var that = this
      that.queryParam.dataDt = [moment().add('days', -1), moment().add('days', -1)]
      that.queryParam.appssidList = []
      that.queryParam.adGroupNameList = []
      // that.queryParam.creativeNameList = []
      that.loadData()
      // that.loadData(this.ipagination.current)
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      if (params.appssidList !== undefined) {
        let arr = params.appssidList
        console.log('params.appssidList---->', params.appssidList)
        if (arr.includes('')) {
          delete params.appssidList
        }
      }
      console.log('params--->', params)
      console.log('params.appssidList--->', params.appssidList)
      getconvertDataAdgroupName(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1])
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    extpand(expanded, record) {
      // if(expanded){
      //   this.innerData = record.dataDetails;
      //
      //   console.log("------------->" + record);
      // } else {
      //   this.innerData = [];
      //   console.log("-------------> im close");
      // }

    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = '新增'
    },
    // model回调
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    getUrl() {
      var params = this.getQueryParams()// 查询条件
      var url = '/api/web/webpublic/statistics/convertDataExcel?startDate=' + params.startDate + '&endDate=' + params.endDate

      if (params.appssidList) {
        url += '&appssidList=' + params.appssidList
      }
      if (params.advertGroup) {
        url += '&advertGroup=' + params.advertGroup
      }
      return url
    },
    downLoadData() {
      const file = {
        fileUrl: this.getUrl(),
        fileName: 'convertDataExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    downLoadData2(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' + params.startDate + '&endDate=' + params.endDate + '&appssidList=' + params.appssidList,
        fileName: 'countLoanDataWithDateExcelColor.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    VisualChart() {
      // console.log('查看哪个产品的图表？', this.queryParam)
      const appssidListValue = this.queryParam.appssidList
      // console.log('appssidListValue-->', appssidListValue)
      // console.log('appssidListValue.lenght-->', appssidListValue.length)
      // console.log('appssidListValue[0]-->', appssidListValue[0])
      if (appssidListValue[0] === undefined) {
        this.$message.error('请选择一个产品！')
      } else if (appssidListValue.length > 1 || appssidListValue[0] === '') {
        this.$message.error('无法查看全部，且只可选择一个产品！')
      } else {
        var paramsechartsarr = this.getQueryParams()
        // console.log('调用弹窗时候的参数', paramsechartsarr)
        getconvertDataAdgroupName(Object.assign({}, paramsechartsarr)).then((res) => {
          if (res.code === 1000) {
            console.log('res--->', res.data)
            if (res.data.rows.length == 1) {
              // console.log('有数据')
              this.$refs.custConvertListModal.sendRequest(paramsechartsarr) //调用弹窗中请求方法
              this.$refs.custConvertListModal.openModal() //打开弹出
              this.$refs.custConvertListModal.clearEcharts() //清空上次绘制数据
            } else if (res.data.rows.length > 1) {
              this.$message.error('目前只支持查看一天的内容！！！')
            } else {
              this.$message.error('查询到0条数据！！！')
            }
          }
        }).catch(e => {
          this.$message.error(e.message)
        })

      }
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
